import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Typography } from '@telus-uds/components-web';
import { Box } from '../../../design/css';

const OrderComments = ({ data }) => {
  return (
    <>
      {data.map((comment, index) => {
        const {
          text,
          createdAt,
          user: { firstName, lastName }
        } = comment;
        const userName = `${firstName.concat(' ', lastName)}: `;
        const commentDate = moment(createdAt).format(
          'dddd, MMMM Do YYYY, h:mm:ss a'
        );
        const key = `comment${index}`;

        return (
          text && (
            <Box key={key} top={4}>
              <Typography variant={{ bold: true, colour: 'brand' }}>
                {userName}
              </Typography>
              <Typography variant={{ weight: 'medium' }}>{`${text} - `}</Typography>
              <Typography variant={{ bold: true, colour: 'positive' }}>
                {commentDate}
              </Typography>
            </Box>
          )
        );
      })}
    </>
  );
};

OrderComments.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      createdAt: PropTypes.string,
      user: PropTypes.shape({
        first_name: PropTypes.string,
        last_name: PropTypes.string
      })
    })
  ).isRequired
};

export default OrderComments;
